<template>

    <SubHeader title="Fiche motif" :breads="[{ name: 'Créer Motif' }]" :action="{}" />
    <div class="row">
        <div class="col-md-12">
            <form @submit.prevent="handleSubmit(data)">

                <div class="row">
                    <div class="col-md-6">
                        <div class="card">

                            <div class="card-header card-header-content-md-between">
                                <h3 class="card-header-title">Détails</h3>
                                <small class="text-muted">Saisie des informations</small>
                            </div>
                            <div class="card-body">
                                <div class="mb-3">
                                    <label class="form-label" for="label">Libellé</label>
                                    <input type="text" name="label" v-model="data.label" id="label" class="form-control" placeholder="Motif"
                                        value="">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br><br>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-body">
                                <button type="submit" class="btn btn-primary">Enregistrer</button>&nbsp;
                                <button type="button" class="btn btn-danger" @click="this.$router.back()">Annuler</button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>
<script>

import SubHeader from "@/layouts/admin/SubHeader.vue"
import { mapActions } from "vuex";
import { mapFields } from "vuex-map-fields";

export default {
    name: "AdminConfigCreateMotif",
    components: {
        SubHeader
    },
    data(){
        return {
            data:{}
        }
    },
    computed: {
        ...mapFields("motif/create", {
            isLoading: "isLoading",
            isSuccess: "isSuccess",
            showMessage: "showMessage",
            message: "message",
            items: "items",
            isCreated:"isCreated"

        }),
    },
    methods:{
        ...mapActions({
            handleSubmit:"motif/create/create",
            reset:"motif/create/resetData"
        })
    },
    watch:{
        isCreated(val){
            if(val){
                this.$router.push({name:"AdminConfigMotif"})
            }
        }
    },
    unmounted(){
        this.reset()
    }
}
</script>
